import {TextInput} from '@dropbox/dig-components/text_fields';
import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {HeadingSettings} from 'plugins/enhancedHeadings/commands';
import {WordCountDisplay} from 'plugins/enhancedHeadings/WordCountWatcher';

interface WordLimitSettingProps {
  settings: HeadingSettings;
  canEdit: boolean;
  headingId: string;
  onWordLimitChange: (value: string) => void;
}

export const WordLimitSetting = ({
  settings,
  canEdit,
  headingId,
  onWordLimitChange,
}: WordLimitSettingProps) => {
  return (
    <Box>
      <Text size="small" isBold style={{marginBottom: '4px'}}>
        Word Limit
      </Text>
      <TextInput
        type="number"
        value={settings.wordLimit || ''}
        onChange={(e) => onWordLimitChange(e.target.value)}
        placeholder="No limit"
        disabled={!canEdit}
      />
      {settings.wordLimit && (
        <Text size="small" color="subtle" style={{marginTop: '2px'}}>
          Current: <WordCountDisplay headingId={headingId} showLimit={false} />
        </Text>
      )}
    </Box>
  );
};
